import {
  CheckTile,
  FormSection,
} from "../../../../../components/propertyDescription/descriptionUi";
import { PROPERTY_PERMISSIONS } from "../constants";
import FurnitureStatusField from "./FurnitureStatusField";

type Props = {
  permissionFlags: Record<string, number>;
  onChange: (field: string, value: unknown) => void;
};

export default function AmenitiesSection({
  permissionFlags,
  onChange,
}: Props) {
  return (
    <FormSection
      title="Amenidades e permissões"
      description="Condições de uso e o que está incluso no valor."
    >
      <FurnitureStatusField
        value={permissionFlags.is_furnished}
        onChange={(next) => onChange("is_furnished", next)}
      />
      <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2 lg:grid-cols-3">
        {PROPERTY_PERMISSIONS.map((permission) => (
          <CheckTile
            key={permission.attributeName}
            label={permission.label}
            checked={!!permissionFlags[permission.attributeName]}
            onChange={(next) => onChange(permission.attributeName, next ? 1 : 0)}
          />
        ))}
      </div>
    </FormSection>
  );
}
